module.exports = __webpack_public_path__ + "img/icon_input_website.38d0292.svg";